<h3>{{ 'common.labels.batchOrders' | transloco }}</h3>

<!-- Container div for everything -->
@if (repo.resource$ | async; as data) {
  <div>
    <app-batch-orders-filter [batch]="batch"></app-batch-orders-filter>
    <div class="spacer-small"></div>
    <!-- Main orders table -->
    @if (data) {
      <div class="table-container">
        <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
        @if (data.length >= 50) {
          <div>
            <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
              [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]"
            showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
            <div class="spacer-small"></div>
          </div>
        }
        <!-- End of conditional paginator at the top -->
        <!-- Orders table -->
        @if (data.length > 0) {
          <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-elevation-z0"
            (matSortChange)="sort($event)">
            <ng-container matColumnDef="referenceNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="referenceNumber"> {{ 'common.labels.referenceNumber' | transloco }}
              </th>
              <td mat-cell *matCellDef="let order">{{ order.referenceNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="isStaged">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="isStaged"> {{ 'common.labels.staged' | transloco }}
              </th>
              <td mat-cell *matCellDef="let order">
                @if (order.isStaged) {
                  <mat-icon>checked</mat-icon>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="isProcessed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="isProcessed"> {{ 'common.labels.processed' | transloco }}
              </th>
              <td mat-cell *matCellDef="let order">
                @if (order.isProcessed) {
                  <mat-icon>checked</mat-icon>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="isSubmitted">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="isSubmitted"> {{ 'common.labels.submitted' | transloco }}
              </th>
              <td mat-cell *matCellDef="let order">
                @if (order.isSubmitted) {
                  <mat-icon>checked</mat-icon>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="orderTypeID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
              <td mat-cell *matCellDef="let order"> {{batch.batchTypeID != vinSightBatchType ? order.orderTypeID : "VINsight"}} </td>
            </ng-container>
            <ng-container matColumnDef="orderStatusTypeID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderStatusTypeID"> {{ 'common.labels.status' | transloco }}
              </th>
              <td mat-cell *matCellDef="let order"> {{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </td>
            </ng-container>
            <ng-container matColumnDef="requestErrors">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">{{ 'common.validation.errors' | transloco }}</th>
              <td mat-cell *matCellDef="let order">
                @if (hasErrors(order)) {
                  <button mat-icon-button color="accent" (click)="viewErrors(order)" [attr.aria-label]="'common.labels.requestErrors' | transloco">
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="requestWarnings">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">{{ 'common.validation.warnings' | transloco }}</th>
              <td mat-cell *matCellDef="let order">
                @if (hasWarnings(order)) {
                  <button mat-icon-button color="accent" (click)="viewValidationWarnings(order)" [attr.aria-label]="'common.labels.requestWarnings' | transloco">
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let order">
                @if (order.orderID) {
                  <button mat-icon-button color="accent" (click)="viewOrder(order, false)" [attr.aria-label]="'common.labels.viewOrder' | transloco">
                    <mat-icon>article</mat-icon>
                  </button>
                }
                @if (order.orderID) {
                  <button mat-icon-button color="accent" (click)="viewOrder(order, true)" [attr.aria-label]="'common.labels.viewOrderInNewTab' | transloco">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
                <!-- Only shows on VinSight batches -->
                @if (shouldShowVinSightViewButtons(order)) {
                  <button mat-icon-button color="accent" (click)="viewVinSights(order, false)" [attr.aria-label]="'bundles.viewVinsights' | transloco">
                    <mat-icon>article</mat-icon>
                  </button>
                }
                @if (shouldShowVinSightViewButtons(order)) {
                  <button mat-icon-button color="accent" (click)="viewVinSights(order, true)" [attr.aria-label]="'bundles.viewVinsightsInNewTab' | transloco">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }
        <!-- End of orders table-->
        <!-- Message while loading (show only if data.length is 0 and loading) -->
        @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
          <div class="padding center padding-top-bottom-50"
            >
            &nbsp;
          </div>
        }
        <!-- Paginator for the bottom -->
        <div class="spacer-small"></div>
        @if (data.length > 0) {
          <mat-paginator [pageSize]="this.repo.pageSize$ | async"
            [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
          [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
        }
        <!-- End of paginator for the bottom -->
      </div>
    }
    <!-- End of main orders table-->
    <!-- Spinner (shows over entire card) -->
    @if (repo.loading$ | async) {
      <div class="loading-spinner-overlay">
        <mat-spinner></mat-spinner>
      </div>
    }
    <!-- End of spinner -->
    <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
  </div>
}
<!-- End of container div for everything -->
